import React from 'react';
import classnames from 'classnames';

import { Section, Layout, SEO, BlogArticles, NewsletterSection } from '..';

import style from './BlogPage.module.less';

export const BlogPage = (props) => {
  const articles = props.data?.allMarkdownRemark?.edges || [];
  const articlesCount = props.data?.allMarkdownRemark?.totalCount || 0;

  return (
    <Layout>
      <SEO title="Blog" />

      <Section className={classnames(style.section, style.firstSection)}>
        <div className={classnames(style.contentNarrow)}>
          <h1 className={style.blogHeader}>Blog</h1>
          <p className={style.articlesCount}>{articlesCount} articles</p>
        </div>
      </Section>

      <BlogArticles articles={articles} />

      <NewsletterSection />
    </Layout>
  );
};
